import { render, staticRenderFns } from "./PersonalSecurityTable.vue?vue&type=template&id=626a4460&scoped=true"
import script from "./PersonalSecurityTable.vue?vue&type=script&lang=js"
export * from "./PersonalSecurityTable.vue?vue&type=script&lang=js"
import style0 from "./PersonalSecurityTable.vue?vue&type=style&index=0&id=626a4460&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626a4460",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('626a4460')) {
      api.createRecord('626a4460', component.options)
    } else {
      api.reload('626a4460', component.options)
    }
    module.hot.accept("./PersonalSecurityTable.vue?vue&type=template&id=626a4460&scoped=true", function () {
      api.rerender('626a4460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationManager/PersonalSecurityTable.vue"
export default component.exports